import { featureCustomizations, features, type FeatureConfig } from '@peanuds/app-shell';

/**
 * Bebawa customer-specific feature defaults.
 *
 *
 * Build-time deployment overrides can replace these values via VITE_FEATURE_FLAGS.
 */
export const featureConfig: FeatureConfig = {
  flags: {
    [features.analytics]: true,
    [features.batchCollections]: false,
    [features.batchPayments]: true,
    [features.cards]: true,
    [features.contacts]: true,
    [features.controlSpending]: true,
    [features.dataExport]: false,
    [features.exchange]: true,
    [features.accounts]: true,
    [features.ibansSwiper]: true,
    [features.money]: true,
    [features.notifications]: true,
    [features.paymentsApproval]: false,
    [features.paymentTags]: false,
    [features.settings]: true,
    [features.settingsNotifications]: true,
    [features.settingsUserControl]: true,
    [features.swiftBeneficiaryCreation]: true,
    [features.totalBalance]: true,
    [features.transactionDetails]: true,
    [features.dashboardTotalBalanceCard]: true,
  },
  customizations: {
    [featureCustomizations.sepaBeneficiaryBicVisible]: false,
    [featureCustomizations.beneficiaryMultipleBankAccountsEnabled]: false,
  },
};
